<div class="dialog-confirm-login-telegram">
  <div
    telegram-check-auth
    [infoText]="'components.dialogConfirmLogin.labels.confirmLoginTelegram' | translate"
    (onLogged)="onLogged()"
    [emitOnSubscribe]="false"
    class="chat-page"
  ></div>
</div>
